<template>
    <div id="job">
        <!-- {{PlugJson}} -->
    </div>
</template>

<script>
export default {
    name:'job'
}
</script>

<style scoped>

</style>